import { systemCode, xs_languageCode } from "../..";
import { getBetTpl } from "../bet-templates/bet-templates";
import { byRanking } from "./byRanking";
import { freezeMap } from "./freezeMap";
import { allAggById } from "./getAllAgg";
import { mainAggById } from "./getMainAgg";
import { cotaOrExtra } from "./isCotaOrExtra";
import { parseBet } from "./parseBet";

export function parseAggregateData(data) {
    function parseBets(sportId, agg, bets) {
        if (bets == null) {
            return [];
        }
        return bets.map(bet => {
            const betTemplate = getBetTpl(sportId, bet.cs);
            if (betTemplate != null) {
                let gd = betTemplate.dsl?.[xs_languageCode] ?? null;
                if (gd?.length > 0) {
                    bet.gd = gd;
                }
            }
            let parsedBet = parseBet(bet, agg, true);

            if (bet.rmks) {
                parsedBet = {
                    ...parsedBet,
                    rmks: bet.rmks
                };
            }

            const betId = `${parsedBet.id}_${parsedBet.handicap}`;

            if (betById[betId] && betById[betId].rmks && !parsedBet.rmks) {
                parsedBet.rmks = betById[betId].rmks;
            }
            betById[betId] = parsedBet;
            return parsedBet;
        }).sort(byRanking);
    }

    function parseAggregata(sportId, agg, isLive) {
        const bets = parseBets(sportId, agg, agg.scs);
        const parsedAgg = {
            idAggregata: agg.id,
            descrizione: agg.ds,
            ranking: agg.rnk,
            isPrincipale: agg.pn,
            scommesse: bets,
            compattate: freezeMap(agg.cmp),
            localeCmpDesc: freezeMap(agg.lcmp),
            sportId,
            whitelistedSystemCodes: agg.wsy,
            isLive
        };
        Object.freeze(parsedAgg);
        bets.forEach(bet => {
            const betId = `${bet.id}_${bet.handicap}`;
            const betIdSport = `${sportId}_${bet.id}_${bet.handicap}`;
            if (agsByBetId[betId] == null) {
                agsByBetId[betId] = [];
            }
            if (agsByBetIdAndSportId[betIdSport] == null) {
                agsByBetIdAndSportId[betIdSport] = [];
            }
            agsByBetId[betId].push(parsedAgg);
            agsByBetIdAndSportId[betIdSport].push(parsedAgg);
        });

        return parsedAgg;
    }

    const betById = window.xs_ag.betById;
    const aggregatePrematchBySportId = window.xs_ag.aggregatePrematchBySportId;
    const aggregateLiveByIdSport = window.xs_ag.aggregateLiveByIdSport;
    const agsByBetId = window.xs_ag.agsByBetId;
    const agsByBetIdAndSportId = window.xs_ag.agsByBetIdAndSportId;
    const sports = data.ags;
    for (let sportId in sports) {
        sportId = parseInt(sportId, 10);
        const sport = sports[sportId];
        if (typeof sport.pr !== 'undefined') {
            aggregatePrematchBySportId[sportId] = {};
            sport.pr.forEach(ag => {
                const loadThis = !ag.wsy || (ag.wsy?.[systemCode]);
                if (loadThis) {
                    const parsedAgg = parseAggregata(sportId, ag, false);
                    aggregatePrematchBySportId[sportId][ag.id] = parsedAgg;
                    if (parsedAgg.idAggregata < 0) {
                        allAggById.set(`pr_${sportId}`, parsedAgg);
                    }
                    if (parsedAgg.isPrincipale) {
                        mainAggById.set(`pr_${sportId}`, parsedAgg);
                    }
                    if (ag.coex === true) {
                        cotaOrExtra.add(`pr_${sportId}_${ag.id}`);
                    }
                }
                else {
                    console.log("Aggregata " + ag.id + " non ammessa per system code " + systemCode);
                }

            });
        }
        if (typeof sport.lv !== 'undefined') {
            aggregateLiveByIdSport[sportId] = {};
            sport.lv.forEach(ag => {
                const parsedAgg = parseAggregata(sportId, ag, true);
                aggregateLiveByIdSport[sportId][ag.id] = parsedAgg;
                if (parsedAgg.idAggregata < 0) {
                    allAggById.set(`lv_${sportId}`, parsedAgg);
                }
                if (parsedAgg.isPrincipale) {
                    mainAggById.set(`lv_${sportId}`, parsedAgg);
                }
                if (ag.coex === true) {
                    cotaOrExtra.add(`lv_${sportId}_${ag.id}`);
                }
            });
        }
    }
}
